module.exports = __webpack_public_path__ + "img/lg-sahara-cement.64c8ea73.png";